import { render } from "./ReactivateAccountView.vue?vue&type=template&id=635fa3a0&scoped=true"
import script from "./ReactivateAccountView.vue?vue&type=script&lang=js"
export * from "./ReactivateAccountView.vue?vue&type=script&lang=js"

import "./ReactivateAccountView.vue?vue&type=style&index=0&id=635fa3a0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635fa3a0"]])

export default __exports__